import { HubAction } from './hub.action';

export class OrderRefreshEditModeAction extends HubAction {
    /**
     *
     */
    constructor(user: string, orderNumber: number) {
        super('RefreshEditMode', user, orderNumber);
    }

    public action(): void {
        // nothing todo
    }
}
